var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232-172q-25 0-42.5-17.5T172-232v-442q0-5 .5-9t3.5-7l54-64q3-4 7-6t9-2h468q5 0 9 2t7 6l54 64q3 3 3.5 7t.5 9v442q0 25-17.5 42.5T728-172H232Zm-16-522h528l-34-40H250l-34 40Zm16 494h496q14 0 23-9t9-23v-434H200v434q0 14 9 23t23 9Zm350-116 104-104-104-104-20 20 84 84-84 84 20 20Zm-202 0 20-20-84-84 84-84-20-20-104 104 104 104ZM200-200v-466 466Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.d4208d6528371dcb393a980a95121169.svg";
export { ForwardRef as ReactComponent };